<script setup lang="ts">
/**
 * UI-kit component
 * Category: Cards
 * Name: KidBalanceItem
 */
import type { KidBalanceItemProps } from '../types/interfaces'

import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons'

import { AppText } from '@shared/ui/typography'
import { AppTooltip } from '@shared/ui/tooltips'
import { AppIcon } from '@shared/ui/icons'

defineOptions({
  name: 'KidBalanceItem',
})

withDefaults(defineProps<KidBalanceItemProps>(), {
  tooltip: null,
})
</script>

<template>
  <div class="kid-balance-item">
    <AppText
      name="body1"
      color="slate-500"
      class="kid-balance-item__label"
    >
      {{ label }}
    </AppText>
    <div class="kid-balance-item__content">
      <AppTooltip
        v-if="tooltip"
        :text="tooltip"
        placement="left"
        size="small"
      >
        <AppIcon
          :icon="faCircleInfo"
          size="small"
          color="slate-500"
        />
      </AppTooltip>
      <AppText name="body1">
        {{ value }}
      </AppText>
    </div>
  </div>
</template>

<style lang="scss" scoped src="../styles/_kid-balance-item.scss" />
